import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeedbackMessagesDirective } from '@app/shared/feedback/feedback-msgs.directive';
import { FeedbackDirective } from '@app/shared/feedback/feedback.directive';
import { ReadOnlyFieldComponent } from '@app/shared/readonlyfield/read-only-field.component';
import { SpinnerComponent } from '@app/shared/spinner/spinner.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha';
import { FeedbackMessageComponent } from './feedback/msg.component';
import { LoaderComponent } from './loader/loader.component';
import { CommonErrorComponent } from './common-error/common-error.component';
import { ToastrModule } from 'ngx-toastr';
import { AsteriskDirective } from '@app/shared/asterisk/asterisk-directive';
import { AlertWithIconComponent } from '@app/shared/alert-with-icon/alert-with-icon.component';
import { CdpIconsComponent } from '@app/shared/icons/icons.component';

/**
 * SharedModule declares common components and reexports frequently used modules (eg FormModule)
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ToastrModule.forRoot({preventDuplicates: true}),
  ],
  declarations: [
    AlertWithIconComponent,
    AsteriskDirective,
    CdpIconsComponent,
    CommonErrorComponent,
    FeedbackDirective,
    FeedbackMessagesDirective,
    FeedbackMessageComponent,
    LoaderComponent,
    ReadOnlyFieldComponent,
    SpinnerComponent,
  ],
  exports: [
    AlertWithIconComponent,
    AsteriskDirective,
    CdpIconsComponent,
    CommonErrorComponent,
    CommonModule,
    FeedbackDirective,
    FeedbackMessagesDirective,
    FeedbackMessageComponent,
    LoaderComponent,
    RecaptchaModule,
    RecaptchaFormsModule,
    ReadOnlyFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    SpinnerComponent,
  ]
})
export class SharedModule { }
